/* eslint-disable indent */
import axios from "axios";
import queryString from 'query-string';
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

// MORE VERBOUSE REPRESENTATION
// The state number is hard to remember. We can make it more verbouse to help
// our own understanding. Here, I put words in an array. Their array indexes represent
// their stae number.
// 0:全部  1:当期  2:未排班  3:在读  4:往期  5:续费
//
// STUDENT_STATES = ["all", "current", "not_enrolled", "enrolled", "archived", "pending_renewal"];
import STUDENT_STATES from "../../constants/student-states";

// PARAM SCHEMA
// It is better to use 1 object param than multiple params, because it is hard to remember
// which param goes where and how many params are needed. If we put all the params in
// one object, we can solve the first problem and if we use object validation such as "Joi"
// we can tell other programmers what params the function is looking for. If they didn't put
// the right value, joy will throw errors and they can change it until it works.
// This is called "error driven development." Errors will correct our developers until
// it works!
//
// Here, we defined which params are used in this controller function.
export const schema = Joi.object().keys({
	schoolId: Joi.number().integer().required(),
	itemPerPage: Joi.number().integer(),
	pageNumber: Joi.number().integer(),
	studentState: Joi.string().valid(STUDENT_STATES).required(),
	searchKeyword: Joi.string().allow('').optional(),
	export: Joi.number().integer().optional(),
	order_by: Joi.number().integer().optional(),
});

export default function getStudentSummary(opts) {

	// VALIDATE PARAMS
	// We throw an error if params are not fulfilled.
	let validateResult = Joi.validate(opts, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }

	// INPUT FACADE
	// We "translate" variable names to something developers can easily understand.
	// For examples, "sState." Is this student state or school state or subscription state?
	// We don't want our developers to guess or visit API documentation to figure this out.
	// We also don't want backend to change this name for us.
	// So instead, we use 'studentState' to accept values from the frontend and change its name to
	// "sState" when sending it back to the backend.
	//
	// Here, we used queryString to translate the object into query string.
	let query = queryString.stringify({
		pageSize: opts.itemPerPage,
		noPage: opts.pageNumber,
		kw: opts.searchKeyword,
		sState: STUDENT_STATES.indexOf(opts.studentState),
		export: opts.export,
		order_by: opts.order_by,
	});

	return new Promise((resolve, reject)=>{
		axios.put(APIAddress, {
        'uri': '/g_stdtsmr/' + opts.schoolId + '/?' + query,
				'method': 'GET',
				'token': localStorage.getItem('token'),
			})
			.then((res) => {
				// OUTPUT FACADE
				// When backend sends us data, the controller should filter out unnecessary data
				// and send the only data needed by the frontend. Sometimes we might want to
				// alter and translate the value. Variable names should be clear and make sense
				// in every context.
				//
        // Here, we only needed data in res object.
				resolve(res.data);
			})
      .catch((err) => {

        reject(err);
      })

	})
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/student/getStudentSummary.js